import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-11e6936e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "goals-unlock-help-box"
};
const _hoisted_2 = {
  class: "goals-tit"
};
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 解锁奖励规则说明 ");
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "help-info"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "tit"
}, "一、什么是解锁福利？"), /*#__PURE__*/_createElementVNode("div", null, "解锁福利是项目发起人在众筹过程中为支持者提供的额外赠品，需满足特定条件方可获取。"), /*#__PURE__*/_createElementVNode("div", {
  class: "tit"
}, "二、解锁条件（需同时满足）"), /*#__PURE__*/_createElementVNode("div", null, "金额达标：众筹项目必须达到发起人设定的筹集金额目标，未达标则所有解锁任务自动失效，无法获得奖励。"), /*#__PURE__*/_createElementVNode("div", null, "任务完成：需满足发起人设置的任务条件（如购买指定回报档、分享项目、邀请好友支持等，具体以项目详情页说明为准）。"), /*#__PURE__*/_createElementVNode("div", {
  class: "tit"
}, "三、奖励发放规则"), /*#__PURE__*/_createElementVNode("div", null, "随订单同步发货"), /*#__PURE__*/_createElementVNode("div", null, "众筹成功结束后，解锁奖品将自动关联至订单，与您购买的主商品（回报档）一起发货。"), /*#__PURE__*/_createElementVNode("div", null, "可在订单详情页查看解锁奖品名称、数量等明细。"), /*#__PURE__*/_createElementVNode("div", null, "收货地址规则"), /*#__PURE__*/_createElementVNode("div", null, "默认地址：解锁奖品地址自动同步订单地址；若多笔订单关联同一解锁订单，地址默认跟随最后一笔订单。"), /*#__PURE__*/_createElementVNode("div", null, "修改限制：如需调整地址，仅可选择关联订单中已填写的地址（无法手动输入全新地址），修改路径："), /*#__PURE__*/_createElementVNode("div", null, "解锁订单详情页 → 地址管理 → 选择已有订单地址。"), /*#__PURE__*/_createElementVNode("div", {
  class: "danger"
}, "温馨提示：若对解锁规则有疑问，可直接联系项目发起人或平台客服咨询～")], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CompPopupBottom = _resolveComponent("CompPopupBottom");
  return _openBlock(), _createBlock(_component_CompPopupBottom, {
    show: $props.show
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("i", {
      class: "close",
      onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => $options.closePopup && $options.closePopup(...args), ["stop"]))
    })]), _hoisted_4])]),
    _: 1
  }, 8, ["show"]);
}